// extracted by mini-css-extract-plugin
export default {"header":"AccountCreatedView_header__YQR1_","description":"AccountCreatedView_description__ZMVG1"};